import React, { Suspense, lazy } from 'react';

// Lazy load page components
const KitchenPage = lazy(() => import('../pages/KitchenPage'));
const AdminPage = lazy(() => import('../pages/AdminPage'));
const AnalyticsPage = lazy(() => import('../pages/AnalyticsPage'));
const CustomerPage = lazy(() => import('../pages/CustomerPage'));
const IngredientsPage = lazy(() => import('../pages/IngredientsPage'));
const StaffPage = lazy(() => import('../pages/StaffPage'));

const ElectronModal = ({ path, onClose }) => {
  if (!path) return null;

  // Map paths to components
  const getComponent = () => {
    switch (path) {
      case '/kitchen.html':
        return <KitchenPage />;
      case '/admin.html':
        return <AdminPage />;
      case '/analytics.html':
        return <AnalyticsPage />;
      case '/customer.html':
        return <CustomerPage />;
      case '/ingredients':
        return <IngredientsPage />;
      case '/staff':
        return <StaffPage />;
      default:
        return <div className="p-8 text-center">Page not found</div>;
    }
  };

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      {/* Modal Card */}
      <div className="relative w-[95%] h-[90%] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 bg-gradient-to-r from-emerald-600 to-teal-600 text-white">
          <h2 className="text-xl font-bold">Preview</h2>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-white bg-opacity-20 hover:bg-opacity-30 transition-all duration-200 hover:scale-110"
            title="Close"
          >
            <i className="fas fa-times text-xl"></i>
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-auto bg-gray-50">
          <Suspense
            fallback={
              <div className="flex items-center justify-center h-full">
                <div className="text-center">
                  <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mb-4"></div>
                  <p className="text-gray-600 font-medium">Loading...</p>
                </div>
              </div>
            }
          >
            {getComponent()}
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default ElectronModal;
